import { InjectionToken } from '@angular/core';
import { PriceCapValues } from './price-cap.configuration';
export const PRICE_CAP_VALID_UNTIL = new InjectionToken<Array<PriceCapValues>>('PRICE_CAP_VALID_UNTIL');
export const PRICE_CAP_TOKEN = new InjectionToken<Array<PriceCapValues>>('PRICE_CAP_TOKEN');
